var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.59151 15.2809C13.2805 15.2809 16.4335 15.8399 16.4335 18.0729C16.4335 20.3059 13.3015 20.8809 9.59151 20.8809C5.90151 20.8809 2.74951 20.3269 2.74951 18.0929C2.74951 15.8589 5.88051 15.2809 9.59151 15.2809Z",
    stroke: "#130F26",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.59157 12.0939C7.16957 12.0939 5.20557 10.1309 5.20557 7.70885C5.20557 5.28685 7.16957 3.32385 9.59157 3.32385C12.0126 3.32385 13.9766 5.28685 13.9766 7.70885C13.9856 10.1219 12.0356 12.0849 9.62257 12.0939H9.59157Z",
    stroke: "#130F26",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4832 10.9556C18.0842 10.7306 19.3172 9.35662 19.3202 7.69362C19.3202 6.05462 18.1252 4.69462 16.5582 4.43762",
    stroke: "#130F26",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5955 14.8063C20.1465 15.0373 21.2295 15.5813 21.2295 16.7013C21.2295 17.4723 20.7195 17.9723 19.8955 18.2853",
    stroke: "#130F26",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.cec234a04ad02a993e1d71d5ae622d5e.svg";
export { ForwardRef as ReactComponent };